/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext} from 'react';

import {Dialog, Snackbar} from '@dvrd/dvr-controls';

import {AppContext} from './appContext';

import InvoicePreview from '../invoice/preview/invoicePreview';

import PremiumFeatureController from '../premium/premiumFeatureController';

import ConfirmCheckout from '../checkout/confirmCheckout';

import RecommendTwoFactor from '../twoFactor/recommend/recommendTwoFactor';

import UpdateController from '../update/updateController';

import GlobalLoader from './globalLoader';

import TrackingDecisionController from '../tracking/trackingDecisionController';

export default function PopupController() {
    const context = useContext(AppContext);

    function renderAuthenticated() {
        if (!context.userContext.user) return null;
        return (
            <>
                <UpdateController />
                <InvoicePreview />
                <ConfirmCheckout />
                <RecommendTwoFactor />
                <TrackingDecisionController />
            </>
        );
    }

    function renderPublic() {
        return (
            <>
                <Snackbar maxSnacks={5} noDuplicates />
                <PremiumFeatureController />
                <GlobalLoader />
                <Dialog className='bolmate-dialog' />
            </>
        );
    }

    return (
        <>
            {renderAuthenticated()}
            {renderPublic()}
        </>
    );
}
